import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { isUrlMatch } from '../utils/urlMatcherUtils.ts';

const MATCH_URL = 'dailymotion.com';
const PATTERN = /^https?:\/\/(www\.)?dailymotion\.com\/.+/;

export const matchDailyMotion: ProviderMatcher = (url) => {
	if (!isUrlMatch(url, MATCH_URL) || !PATTERN.test(url)) {
		return null;
	}
	// Legacy embed used Flash. Modern browsers can no longer render it.
	return {
		kind: 'deprecated',
		provider: 'DailyMotion',
		embedUrl: url.replace('/video/', '/swf/video/'),
		width: '',
		height: '',
		hostLabel: 'flash-deprecated',
	};
};
